import React from "react";
import NewCustomer from "./components/stripe/NewCustomer";

function App() {
  return (
    <div className="App">
      <NewCustomer />
    </div>
  );
}

export default App;
